export const searchStyles = {
  searchBarContainer: {
    display: "flex",
    fontSize: "12px",
    marginRight: 0,
    marginBottom: "10px",
    "@media (minWidth: 1024px)": {
      marginRight: "20px",
      marginBottom: 0
    }
  },
  searchBarContainerRemo: {
    display: "flex",
    fontSize: "12px",
    marginRight: 0,
    marginBottom: "15px"
  },
  searchBarItem: {
    display: "flex",
    alignSelf: "flex-end",
    alignItems: "center",
    height: "31px"
  },
  searchActiveLabel: {
    marginLeft: "5px",
    "@media (minWidth: 370px)": {
      marginLeft: 0
    }
  },
  searchInput: {
    height: "25px",
    borderRadius: 0,
    paddingLeft: "5px",
    width: "155px",
    border: "1px solid #333333"
  }
};
